import { collapseController, modalController } from "./controllers";

function targetId(binding) {
    return binding.value || Object.keys(binding.modifiers || {})[0];
}

function directiveFor(controller, tracksState = false) {
    function subscribe(element) {
        element.__sbUnsubscribe?.();
        if (!tracksState) { return; }
        const update = (visible) => {
            element.setAttribute("aria-controls", element.__sbTargetId);
            element.setAttribute("aria-expanded", String(visible));
            element.classList.toggle("collapsed", !visible);
        };
        element.__sbUpdateState = update;
        element.__sbUnsubscribe = controller.subscribe(element.__sbTargetId, update);
        update(controller.isVisible(element.__sbTargetId));
    }

    return {
        mounted(element, binding) {
            element.__sbTargetId = targetId(binding);
            element.__sbHandler = (event) => {
                event.preventDefault();
                controller.toggle(element.__sbTargetId);
            };
            element.addEventListener("click", element.__sbHandler);
            subscribe(element);
        },
        updated(element, binding) {
            const nextId = targetId(binding);
            if (nextId === element.__sbTargetId) { return; }
            element.__sbTargetId = nextId;
            subscribe(element);
        },
        unmounted(element) {
            element.removeEventListener("click", element.__sbHandler);
            element.__sbUnsubscribe?.();
            delete element.__sbHandler;
            delete element.__sbUnsubscribe;
            delete element.__sbUpdateState;
            delete element.__sbTargetId;
        },
    };
}

export const SbModalDirective = directiveFor(modalController);
export const SbToggleDirective = directiveFor(collapseController, true);
